import React, { useState } from 'react';

import { format as formatDate, addMonths, subMonths } from 'date-fns';
import { ru } from 'date-fns/locale';
import { PickersCalendarHeaderProps } from '@mui/x-date-pickers';
import { IconButton, Fade } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';

import { Box } from '../../Box';
import { Typography } from '../../Typography';

import useStyles from './CalendarHeader.styles';

/**
 * CalendarHeader - компонент для отображения заголовка календаря.
 *
 * @param {PickersCalendarHeaderProps<Date>} props - Свойства компонента.
 * @param {Date} [props.currentMonth] - Дата ображаемого месяца.
 * @param {(date: Date, slideDirection: SlideDirection) => void} [props.onMonthChange] - Функция для переключения месяца.
 * @returns {JSX.Element} Возвращает JSX-элемент представляющий компонент CalendarHeader.
 */

export const CalendarHeader: React.FC<PickersCalendarHeaderProps<Date>> = ({
  currentMonth,
  onMonthChange,
}) => {
  const { classes } = useStyles();

  const [isFading, setIsFading] = useState(false);

  const selectNextMonth = () => {
    setIsFading(true);
    onMonthChange(addMonths(currentMonth, 1), 'left');
    setTimeout(() => {
      setIsFading(false);
    }, 200);
  };

  const selectPreviousMonth = () => {
    setIsFading(true);
    onMonthChange(subMonths(currentMonth, 1), 'right');
    setTimeout(() => {
      setIsFading(false);
    }, 200);
  };

  return (
    <div className={classes.switchHeader}>
      <IconButton
        className={classes.iconButton}
        onClick={selectPreviousMonth}
        title="Предыдущий месяц"
      >
        <ChevronLeft />
      </IconButton>
      <div className={classes.fadeContainer}>
        <Fade
          in={!isFading}
          timeout={200}
          easing={{ enter: 'cubic-bezier(0.1, 1, 0.6, 1)' }}
        >
          <Box width="fit-content">
            <Typography variant="body2" className={classes.lable}>
              {formatDate(currentMonth, 'LLLL yyyy', { locale: ru })}
            </Typography>
          </Box>
        </Fade>
      </div>
      <IconButton
        className={classes.iconButton}
        onClick={selectNextMonth}
        title="Следующий месяц"
      >
        <ChevronRight />
      </IconButton>
    </div>
  );
};
